import { Tag } from 'antd';
import { trangThaiDangKyDaoTao } from '../../constants';
const trangThaiTagMap: Record<number, { color: string; label: string, title: string }> = {
    [trangThaiDangKyDaoTao.chuaDangKy]: { color: "warning", label: "Chưa ĐK", title:"Chưa đăng ký"},
    [trangThaiDangKyDaoTao.khoiTao]: { color: "processing", label: "Khởi tạo", title: "Khởi tạo" },
    [trangThaiDangKyDaoTao.thuHoi]: { color: "warning", label: "Thu hồi", title: "Khởi tạo" },
    [trangThaiDangKyDaoTao.trinhLanhDaoPhong]: { color: "cyan", label: "Trình LĐP", title: "Trình Lãnh đạo phòng" },
    [trangThaiDangKyDaoTao.lanhDaoPhongTuChoi]: { color: "error", label: "LĐP từ chối", title: "Lãnh đạo phòng từ chối" },
    [trangThaiDangKyDaoTao.duyetCapPhong]: { color: "success", label: "LĐP duyệt", title: "Lãnh đạo phòng đã duyệt" },
    [trangThaiDangKyDaoTao.chuyenVanPhong]: { color: "purple", label: "Chuyển VP", title: "Chuyển văn phòng" },
    [trangThaiDangKyDaoTao.lanhDaoQuyTuChoi]: { color: "error", label: "LĐQ từ chối", title: "Lãnh đạo Quỹ từ chối" },
    [trangThaiDangKyDaoTao.trinhPhoGiamDoc]: { color: "blue", label: "Trình Phó Giám đốc", title: "Trình Phó Giám đốc" },
    [trangThaiDangKyDaoTao.phoGiamDocTuChoi]: { color: "error", label: "Phó Giám đốc từ chối", title: "Phó Giám đốc từ chối" },
    [trangThaiDangKyDaoTao.trinhGiamDoc]: { color: "blue", label: "Trình Giám đốc", title: "Trình Giám đốc" },
    [trangThaiDangKyDaoTao.trinhGiamDoc]: { color: "error", label: "Giám đốc từ chối", title: "Giám đốc từ chối" },
    [trangThaiDangKyDaoTao.pheDuyet]: { color: "success", label: "Duyệt", title: "Duyệt" },
};

const TrangThaiTag = ({
    value,
    ngayKetThuc
}: {
    value?: number;
    ngayKetThuc?: string;
}) => {
    if (value == null) return null;
    
    if (
        ngayKetThuc &&
        value === trangThaiDangKyDaoTao.chuaDangKy
    ) {
        const ngayKT = new Date(ngayKetThuc);
        const now = new Date();

        ngayKT.setHours(0, 0, 0, 0);
        now.setHours(0, 0, 0, 0);

        if (ngayKT < now) {
            return <Tag color="warning">Không đăng ký</Tag>;
        }
    }

    const config = trangThaiTagMap[value];
    if (!config) return null;

    return <Tag title={config.title} color={config.color}>{config.label}</Tag>;
};

export default TrangThaiTag;